module.exports = __webpack_public_path__ + "img/account.86640141.svg";